import * as React from 'react';

import { Col, Row, notification } from 'antd';
import { Navigate, useLocation } from 'react-router';
import { useAppDispatch, useAppSelector } from '@reduxHelpers';

import { LocationState } from '@customTypes/locationState';
import { LoginForm } from '@/components/forms';
import { PageWrapper } from '@components/pageWrapper';
import { UnlockOutlined } from '@ant-design/icons';
import { WelcomeHeader } from '@components/pageHeader';
import { login } from '@modules/securityModule';
import { useApiErrorMessage } from '@/hooks/useApiErrorMessage';
import { useAppRoutes } from '@/hooks';
import { useTranslation } from 'react-i18next';

interface LoginPageProps {

}

export const LoginPage: React.FC<LoginPageProps> = (props) => {
    const { t } = useTranslation();
    const { getErrorMessage } = useApiErrorMessage();

    const dispatch = useAppDispatch();

    const appRoutes = useAppRoutes();
    const location = useLocation();

    const isAuthenticated = useAppSelector((state) => state.security.isAuthenticated);
    const adUser = useAppSelector((state) => state.security.adUser);

    const [isLoading, setIsLoading] = React.useState(false);
    const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);

    const { state } = location;
    const from = (state as LocationState)?.from;

    if (redirectToReferrer === true) {
        return <Navigate to={from ?? appRoutes.admin.path} />;
    }

    return (
        <PageWrapper
            isNonIdeal={isAuthenticated}
            nonIdealHeader={
                adUser
                    ? t('Pages.LoginPage.already_logged_in_message_personal', { user: adUser.displayName })
                    : t('Pages.LoginPage.already_logged_in_message')
            }
            nonIdealActions={['home', 'logout']}
            nonIdealIconType={<UnlockOutlined />}
            pageTitle={<WelcomeHeader />}
        >
            <Row
                align="middle"
                justify="center"
            >
                <Col>
                    <Row
                        align="middle"
                        justify="center"
                    >
                        <Col
                            span={24}
                            style={{ textAlign: 'center', fontSize: '2em' }}
                        >
                            {t('Pages.LoginPage.login_header')}
                        </Col>
                        <Col
                            span={24}
                            style={{ textAlign: 'center' }}
                        >
                            {t('Pages.LoginPage.login_message')}
                        </Col>

                        <Col span={24}>
                            <LoginForm
                                isLoading={isLoading}
                                onFinish={async (values) => {
                                    setIsLoading(true);

                                    const action = await dispatch(login({ username: values.username, password: values.password }));

                                    setIsLoading(false);

                                    if (login.fulfilled.match(action)) {
                                        setRedirectToReferrer(true);
                                    } else {
                                        notification.error({
                                            description: getErrorMessage(action.payload),
                                            message: t('Pages.LoginPage.login_error'),
                                            placement: 'topRight',
                                        });
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </PageWrapper>
    );
};